/**
 *
 * QuickOrder
 *
 */

// Node_Module Imports
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Input from 'common-ui-components/dist/components/Atoms/Input';
import Quantity from 'common-ui-components/dist/components/Molecules/Quantity';
import Button from 'common-ui-components/dist/components/Atoms/Button';

import './QuickOrder.scss';

class QuickOrder extends PureComponent {
  constructor(props) {
    super(props);
    const { skuNumber } = this.props;
    this.state = {
      inputValue: skuNumber || '',
      qty: 1,
    };
    this.setInputValue = this.setInputValue.bind(this);
    this.setQtyValue = this.setQtyValue.bind(this);
  }

  setQtyValue(qty) {
    this.setState({ qty });
  }

  setInputValue(inputValue) {
    this.setState({ inputValue });
  }

  reset() {
    this.setState({
      inputValue: '',
      qty: 1,
    });
  }

  render() {
    const { inputValue, qty } = this.state;
    const {
      inputPlaceholder,
      qtyPlaceholder,
      submitButtonLabel,
      onSubmit,
      className,
      pageId,
      elementLocator,
      skuNumCustomClass,
      qtyCustomClass,
    } = this.props;
    return (
      <div className={`row quick-order-parent ${className}`}>
        <Input
          id={`code-${pageId}`}
          type="text"
          name="quickOrder"
          placeholder={inputPlaceholder}
          value={inputValue}
          className={`quick-order-sku ${skuNumCustomClass}`}
          onChange={this.setInputValue}
          elementLocator={`code-${elementLocator}`}
        />
        <Quantity
          id={`quickOrderQty-${pageId}`}
          value={qty}
          placeholder={qtyPlaceholder}
          updateCartQuantity={this.setQtyValue}
          minLength={1}
          className={`quick-order-qty ${qtyCustomClass}`}
          elementLocator={`quantity-${elementLocator}`}
          reset={this.reset}
        />
        <Button
          id={`add-to-cart-button-${pageId}`}
          className="primary quick-order-submit-button"
          disabled={!inputValue.trim()}
          {...{ onClick: () => onSubmit(inputValue.trim(), qty) }}
          elementLocator={`add-to-cart-button-${elementLocator}`}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  }
}

QuickOrder.propTypes = {
  inputPlaceholder: PropTypes.string,
  qtyPlaceholder: PropTypes.string,
  submitButtonLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  pageId: PropTypes.string,
  elementLocator: PropTypes.string,
  skuNumber: PropTypes.string,
  skuNumCustomClass: PropTypes.string,
  qtyCustomClass: PropTypes.string,
};

QuickOrder.defaultProps = {
  skuNumber: '',
  skuNumCustomClass: '',
  qtyCustomClass: '',
  inputPlaceholder: '',
  qtyPlaceholder: '',
  submitButtonLabel: '',
  onSubmit: () => {
    /* default onSubmit handler */
  },
  className: '',
  pageId: '',
  elementLocator: 'cart',
};

export default QuickOrder;
